export const ROLE_ADMIN = 'Admin';
export const ROLE_EDITOR = 'Editor';
export const ROLE_USER = 'User';



// WEBPACK FOOTER //
// ./src/constants/userConstants.js